import { Component, OnInit, OnDestroy } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers/index';

import * as fromRedDatas from './../store/red-data.actions';
import { RedData } from '../models/red-data.model';
import { Subscription, Observable } from 'rxjs';
import { getRedDatas, getIsLoading } from '../store/red-data.selectors';
import { take, map } from 'rxjs/operators';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { ConfirmSaveModalComponent } from '../../shared/components/confirm-save-modal/confirm-save-modal.component'
import { RedDatasModalComponent } from '../../shared/components/red-data-modal/red-data-modal.component';
import { AngularFireAuth } from '@angular/fire/auth';

 

@Component({
  selector: 'app-red-data',
  templateUrl: './red-data.component.html',  
  styleUrls: ['./red-data.scss']
})
export class RedDatasComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean>;
  reddatas: RedData[] | null;
  modalRef: MDBModalRef;

  reddatasSub: Subscription;

  modalConfig = {
    class: 'modal-dialog-centered'
  };

  lastRedDataIndex: number;

  constructor(private modalService: MDBModalService, private store: Store<AppState>, private afAuth: AngularFireAuth) { }

  ngOnInit() {
    this.isLoading$ = this.store.select(getIsLoading);

    this.reddatasSub = this.store.select(getRedDatas).pipe(
      map( (reddatas: RedData[]) => {
        if (this.user && !reddatas) {
          this.store.dispatch(new fromRedDatas.RedDatasQuery());
        }
        return reddatas;
      })
    )
    .subscribe( (reddatas: RedData[]) => {
      if (reddatas && reddatas.length !== 0) {
        const index: number = Number(reddatas[reddatas.length - 1].id);
        this.lastRedDataIndex = index;
      } else {
        this.lastRedDataIndex = 0;
      }

      this.reddatas = reddatas;
    });
  }

  get user() {
    return this.afAuth.auth.currentUser;
  }

  ngOnDestroy() {
    if (this.reddatasSub) {
      this.reddatasSub.unsubscribe();
    }
  }

  onAddRedData() {
    this.modalRef = this.modalService.show(RedDatasModalComponent, this.modalConfig);

    this.modalRef.content.heading = 'Add new company';
    this.modalRef.content.reddata.id = this.lastRedDataIndex + 1;

    this.modalRef.content.reddataData.pipe(take(1)).subscribe( (reddataData: RedData) => {
      this.store.dispatch(new fromRedDatas.RedDatasAdded({ reddata: reddataData }));
    });
  }

  openEditRedDataModal(reddata: RedData) {
    this.modalRef = this.modalService.show(RedDatasModalComponent, this.modalConfig);

    this.modalRef.content.heading = 'Save company';
    const myDate = new Date().getDate();
    const myDate2 = new Date().getMonth() + 1;
    const myDate3 = new Date().getUTCFullYear();
    const fullDate = [myDate, myDate2, myDate3].join('/');
    const reddataCopy = {
      key: reddata.key,
      id: reddata.id || null,
      description: reddata.description || null,
      phone: reddata.phone || null,
      page: reddata.page || null,
      sic: reddata.sic || null,
      address: reddata.address,
      name: reddata.name || null,
      incdate: reddata.incdate || null,
      postcode: reddata.postcode,
      date: reddata.date,
      status: reddata.status || 'Approved',
      industry: reddata.sic,
      username: reddata.phone || null,
      lead: reddata.lead,
      datesaved: fullDate
      
    
     };
    this.modalRef.content.reddata = reddataCopy;

    this.modalRef.content.reddataData.pipe(take(1)).subscribe( (reddataData: RedData) => {
      this.store.dispatch(new fromRedDatas.RedDatasEdited({ reddata: reddataData }));
    });
  }

  openConfirmModal(reddata: RedData) {
    this.modalRef = this.modalService.show(ConfirmModalComponent, this.modalConfig);

    this.modalRef.content.confirmation.pipe(take(1)).subscribe( (confirmation: boolean) => {
      if (confirmation) {
        this.store.dispatch(new fromRedDatas.RedDatasDeleted({ reddata }));
      }
    });
  }

  openConfirmModalSec(reddata: RedData) {
    this.modalRef = this.modalService.show(ConfirmModalComponent, this.modalConfig);

    this.modalRef.content.confirmation.pipe(take(1)).subscribe( (confirmation: boolean) => {
      if (confirmation) {
        this.store.dispatch(new fromRedDatas.RedDatasDeletedAll({ reddata }));
      }
    });
  }

  openConfirmSaveModal(reddata: RedData) {
    this.modalRef = this.modalService.show(ConfirmSaveModalComponent, this.modalConfig);

    this.modalRef.content.confirmation.pipe(take(1)).subscribe( (confirmation: boolean) => {
      if (confirmation) {
        this.store.dispatch(new fromRedDatas.RedDatasSaved({ reddata }));
      }
    });

  }

  

  onRedDataEdit(reddata: RedData) {
    this.openEditRedDataModal(reddata);
  }

  onRedDataSave(reddata: RedData) {
    this.openEditRedDataModal(reddata);
  }

  onRedDataDelete(reddata: RedData) {
    this.openConfirmModal(reddata);
  }

  onRedDataDeleteAll(reddata: RedData) {
    this.openConfirmModalSec(reddata);
  }

}
